export default "__VITE_ASSET__DuUHQXTX__"